<template>
  <article class="cur_con_wrapper">
    <div class="cur_con">
      <header class="header">
        <i class="iconfont">&#xe7c0;</i>
        <h2>
          {{$t("title.yingyang")}}
          <span v-show="showData">({{ startTime }} -- {{ endTime }})</span>
        </h2>
      </header>
      <div v-show="showData">
        <div class="box">
          <div
            class="box-item"
            v-for="item in elementList"
            :key="item.id"
            @click="showDetails(item)"
          >
            <i :class="['value','normal']">{{
              item.id
            }}</i>
            <!-- <i :class="['value', item.color !== '' ? item.color : '']">{{
              item.id
            }}</i> -->
          </div>

        </div>
        <p class="chartTip">* {{$t("tag.jiankang")}}</p>
        <div class="read">
          <header>
            <h2 class=txt>{{$t("title.yanse")}}</h2>
          </header>
          <ul class="legend">
            <li>
              <i class="red"></i>
              <span>{{$t('tag.hanliangpiandi')}}</span>
            </li>
            <li>
              <i class="blue"></i>
              <span>{{$t('tag.hanliangzhengchang')}}</span>
            </li>
            <li>
              <i class="orange"></i>
              <span>{{$t('tag.hanliangpiangao')}}</span>
            </li>
          </ul>
        </div>
        <div class="read">
          <header>
            <i class="iconfont">&#xe61d;</i>
            <h2>{{ $t("title.secondaryTitle.zangfuReport") }}</h2>
          </header>
          <div class="content">
            <div
              :class="['article', contentShow ? 'show' : 'hidden']"
              v-html="content"
            ></div>
            <div
              :class="['mask', contentShow ? 'show' : 'hidden']"
              @click="contentToggle"
            >
              <i
                class="iconfont"
                v-show="!contentShow"
              >&#xe632;</i>
              <i
                class="iconfont"
                v-show="contentShow"
              >&#xe633;</i>
            </div>
          </div>
        </div>
      </div>
      <p
        v-show="!showData"
        class="nodata"
      >{{ $t("tag.zangfu.noday") }}</p>
    </div>
  </article>
</template>

<script>

export default {
  name: "monthNutrition",
  props: {
    sendTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showData: true,
      emit: {},
      startTime: "",
      endTime: "",
      rateData: [],
      contentShow: false,
      titles: "丑时",
      content: "蛋白质是人体重要的营养成分，蛋白质不足会引起人体基础代谢的相对减少，从而会引起肌肉数量也相对的减少，同时会出现营养性水肿。当饮食中蛋白质缺乏时，组织蛋白分解的快，合成的慢，可能会出现消化不良，不吸收营养，腹泻，肾上腺皮质功能减退。儿童出现蛋白质低会导致骨骼生长缓慢，智力发育障碍，如果蛋白质长期的摄入不足，就会形成营养性不良水肿。所以当低蛋白的时候，首先要进食高蛋白的食物，比如鸡蛋、牛奶、鱼肉、虾，这些都能够提供白蛋白质。",
      riskData: [],
      ifshow: true,
      statec: "",
      elementList: this.$t("elementList"),
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  watch: {
    sendTime: function () {
      // this.getDayDataInfo();
    }
  },
  mounted() { },

  methods: {
    showDetails(items) {
      this.$alertPl.show({
        title: items.id,
        text: "<p>通过对您今日健康数据监测分析发现，您今日（什么营养元素）含量（偏低/偏高）。</p><h1>蛋白质过高的危害：<h1><p>1、如果蛋白质含量过高，可能会转化成脂肪，一方面会引起动脉粥样硬化的风险性增高，另外一方面，脂肪可以使人体处于酸性的环境，不利于人体健康。</p><p>2、身体蛋白质含量高，会加重肝脏和肾脏的负担，蛋白质在体内可以分解代谢，产生尿素氮这种小分子毒素，如果蛋白质过高分解产生的尿素氮也会更高，从而引起毒素水平升高情况，加重肝、肾负担。</p><p>各种红肉和家禽肉，如兔、鸡、鸭、猪皮、肝、牛羊肉的蛋白质含量非常高，要尽量避免食用。</p>",
        confirmMsg: "关闭"
      });
    },
    getDayDataInfo() {
      let postData = {
        date: this.sendTime,
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token
      };
      this.$axios
        .getDayviscera(this.appType, postData)
        .then(this.getDayDataInfoSucc);
    },
    getDayDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        this.showData = true;
        const data = res.data;
        this.rateData = data.rateData;
        this.riskData = data.riskData;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
        this.statec = data.statec;
        let p;
        this.content = "";
        for (let item of this.$t("zangfu.day." + this.statec)) {
          p = "<p>" + item + "</p>";
          this.content += p;
        }

        let visceraList = data.rateData;
        let color = [];
        for (let i in visceraList) {
          color.push(visceraList[i].state);
        }
        for (let j in this.hour) {
          this.hour[j].color = color[j];
        }
      } else {
        this.showData = false;
      }
      this.emit.code = res.code;
      this.$emit("dayvisceracode", this.emit);
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    },
    clickWarnData(index) {
      this.riskData[index].ifshow = !this.riskData[index].ifshow;
      this.$set(this.riskData, index, this.riskData[index]);
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/CurrentData.styl';
@import '~styles/healthelement.styl';

.cur_con_wrapper {
  .cur_con {
    .nodata {
      text-indent: 0.8rem;
      margin-top: 0.3rem;
    }

    .box {
      display: flex;
      // width 5.8rem
      // margin 0 auto
      margin-top: 0.4rem;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;

      .box-item {
        margin: 0 0.12rem 0.3rem 0.12rem;
        width: 20%;
        text-align: center;
        font-size: 0.24rem;

        i, span {
          display: block;
        }

        .value {
          color: #fff;
          border-radius: 0.1rem;
          padding: 0.14rem 0;
          background-color: #ddd;

          &.red {
            background-color: $redText;
          }

          &.orange {
            background-color: $orangeText;
          }

          &.normal {
            background: $blueText;
          }
        }

        span {
          color: #b5b5b5;
          margin-top: 0.1rem;
        }
      }
    }

    .item_list {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 0.3rem;

      li {
        align-items: center;
        width: 33.33%;
        // margin .3rem 0.2rem
        text-align: center;

        .value {
          display: flex;
          justify-content: center;
          height: 0.4rem;
          margin-bottom: 0.2rem;

          &.red {
            color: $redText;
          }

          &.orange {
            color: $orangeText;
          }

          &.purple {
            color: $purpleText;
          }

          strong {
            font-size: 0.4rem;
            font-weight: bold;
          }

          i {
            margin: 0.14rem 0 0 0.02rem;
            font-size: 0.24rem;
          }
        }

        p.title {
          border-bottom: none !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/month-data/components/monthNutrition.vue